import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    flex: '1',
    display: 'flex'
  },

  content: {
    flex: '1',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  article: {
    flex: '1'
  }
}))

export default useStyles
